import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule,  } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { httpInterceptorProviders } from './interceptors/index';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthGuard } from './guards/auth.guard';
import { CookieService } from 'ngx-cookie-service';
import { FrontLayoutModule } from '../app/front-layout/front-layout.module';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { YearfourComponent } from './calender/yearfour/yearfour.component';
//bookingModal
import { BookingModalComponent } from './calender/gcsetimetable/booking-modal/booking-modal.component';
import { MatDialogModule } from '@angular/material/dialog';

import { NgChartsModule } from 'ng2-charts';

import { OnlineTestsComponent } from './calender/Online/online-tests/online-tests.component';
import { YearFourOnlineComponent } from './calender/Online/year-four-online/year-four-online.component';
import { ElevPlusOnlineComponent } from './calender/Online/elev-plus-online/elev-plus-online.component';
import { LlpPageComponent } from './llp-page/llp-page.component';
//import { DataScienceComponent } from './front-layout/data-science/data-science.component';

@NgModule({ declarations: [
        AppComponent,
        PageNotFoundComponent,
        YearfourComponent,
        BookingModalComponent,
        OnlineTestsComponent,
        YearFourOnlineComponent,
        ElevPlusOnlineComponent,
        LlpPageComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        FrontLayoutModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatDialogModule,
        NgChartsModule], providers: [AuthGuard, httpInterceptorProviders, Title, CookieService, provideHttpClient(withInterceptorsFromDi())] })
export class AppModule { }
